module.exports = __webpack_public_path__ + "static/AboutImg2-16fd453132906add8868e2280ff80248.jpg";